var _rect, _rect2, _text, _text2, _rect3, _rect4, _text3, _line, _rect5, _text4, _line2, _rect6, _text5, _line3, _rect7, _text6, _text7, _text8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgP16(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 600,
    height: 340,
    viewBox: "0 0 600 340",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 340,
    fill: "#0d1b2a"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 560,
    height: 300,
    rx: 8,
    fill: "#112240",
    stroke: "#64ffda",
    strokeWidth: 1.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 90,
    fontFamily: "monospace",
    fontSize: 20,
    fill: "#64ffda",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "Pocket Data Scientist")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 125,
    fontFamily: "monospace",
    fontSize: 13,
    fill: "#8892b0",
    textAnchor: "middle"
  }, "GenAI AutoML Pipeline")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 145,
    width: 440,
    height: 2,
    fill: "#64ffda",
    opacity: 0.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 185,
    width: 90,
    height: 35,
    rx: 5,
    fill: "#1e3a5f",
    stroke: "#64ffda",
    strokeWidth: 1
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 105,
    y: 207,
    fontFamily: "monospace",
    fontSize: 10,
    fill: "#64ffda",
    textAnchor: "middle"
  }, "Data Input")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 202,
    x2: 185,
    y2: 202,
    stroke: "#64ffda",
    strokeWidth: 1.5,
    markerEnd: "url(#arr)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 185,
    width: 90,
    height: 35,
    rx: 5,
    fill: "#1e3a5f",
    stroke: "#64ffda",
    strokeWidth: 1
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 230,
    y: 207,
    fontFamily: "monospace",
    fontSize: 10,
    fill: "#64ffda",
    textAnchor: "middle"
  }, "RAG Query")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 275,
    y1: 202,
    x2: 310,
    y2: 202,
    stroke: "#64ffda",
    strokeWidth: 1.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 185,
    width: 90,
    height: 35,
    rx: 5,
    fill: "#1e3a5f",
    stroke: "#64ffda",
    strokeWidth: 1
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 355,
    y: 207,
    fontFamily: "monospace",
    fontSize: 10,
    fill: "#64ffda",
    textAnchor: "middle"
  }, "AutoML")), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 202,
    x2: 435,
    y2: 202,
    stroke: "#64ffda",
    strokeWidth: 1.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 435,
    y: 185,
    width: 90,
    height: 35,
    rx: 5,
    fill: "#1e3a5f",
    stroke: "#64ffda",
    strokeWidth: 1
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 207,
    fontFamily: "monospace",
    fontSize: 10,
    fill: "#64ffda",
    textAnchor: "middle"
  }, "Deploy")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 275,
    fontFamily: "monospace",
    fontSize: 12,
    fill: "#a8b2d8",
    textAnchor: "middle"
  }, "Streamlit \xB7 OpenAI \xB7 HuggingFace \xB7 Docker")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 300,
    fontFamily: "monospace",
    fontSize: 11,
    fill: "#8892b0",
    textAnchor: "middle"
  }, "Helped 50+ Canadians achieve jobs")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgP16);
export default __webpack_public_path__ + "static/media/p16.f162310b60452a96ae42b857f4b8ef71.svg";
export { ForwardRef as ReactComponent };